import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple, FuseAnimate} from '@fuse';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';
import { Paper, Grid, Chip, Divider, Typography } from '@material-ui/core';
// import Pagination from "material-ui-flat-pagination";

import HomeIcon from '@material-ui/icons/Home';

const styles = theme => ({
    layoutRoot: {},
    pagingPeringkat: {
        textAlign: 'right'
    },
    tabSelected: {
        borderBottom: '5px solid #4EBAE7',
        background: '#ECEFF1',
        color: 'white'
    },
    divHasilRekomendasi: {
        padding: 10,
        borderLeft: '0px solid #ccc',
        background: '#ECEFF1'
    }
});


const bulan = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember'
]

class DetailHasilSupervisi extends Component {
    state = {
        error:0,
        routeParams:{
            foo: 'bar',
            sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
            tahun: localStorage.getItem('tahun'),
            token: localStorage.getItem('jwt_token')
        },
        valueTab: 0,
        tabValue: 0
    }

    goTolink = (url) => {
        this.props.history.push(url);
    };

    componentDidMount = () => {
        this.props.setJudul('Hasil Supervisi');
        this.props.setLoadingBesar(true);

        this.setState({
            routeParams: {
                ...this.state.routeParams,
                jenis: (this.state.tabValue+1)
            }
        },()=>{
            this.props.getPengawas(this.state.routeParams).then((result)=>{
                // this.props.setLoadingBesar(false);
                this.setState({
                    ...this.state,
                    routeParams: {
                        ...this.state.routeParams,
                        // jenis: (this.state.tabValue+1),
                        pengguna_id: this.props.pengawas.rows[0].pengguna_id,
                        bukan_pengguna_id: null,
                        jenis: this.props.location.pathname.split('/')[3],
                        supervisi_pengawas_id: this.props.location.pathname.split('/')[2]
                    }
                },()=>{
                    this.props.getSupervisi(this.state.routeParams).then((result)=>{
                        this.props.setLoadingBesar(false);
                    });
                    
                })
            });
        });

    }

    handleChangeTab = (e,value) => {
        this.props.setLoadingBesar(true);
        this.setState({
            ...this.state,
            tabValue: value,
            routeParams: {
                ...this.state.routeParams,
                jenis: (value+1),
                bukan_pengguna_id: null
            }
        },()=>{
            this.props.getSupervisi(this.state.routeParams).then((result)=>{
                this.props.setLoadingBesar(false);

                this.setState({
                    routeParams: {
                        ...this.state.routeParams,
                        jenis: 1,
                        bukan_pengguna_id: this.props.pengawas.rows[0].pengguna_id
                    }
                },()=>{
                    this.props.getSupervisiPengawasLain(this.state.routeParams).then((result)=>{
                        this.props.setLoadingBesar(false);
                    });
                });
            });
        });
    }

    render()
    {
        const {classes} = this.props;
        
        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                content={
                    <FuseAnimate
                        animation="transition.slideRightBigIn"
                        duration={400}
                        delay={400}
                    >
                        <div style={{width: '100%', padding: 10}} className="konten-utama">
                            <div style={{minHeight: 10, width: '100%', background: '#4EBBE8', overflow: 'auto', maxHeight: '42px', display: 'inline-flex'}}>
                                <Chip
                                    icon={<HomeIcon/>}
                                    label=""
                                    className={this.props.classes.chip}
                                    color="primary"
                                    style={{justifyContent: 'start', marginLeft: 0, padding: 5, borderRadius: 0, borderRight: '1px solid #ccc', paddingLeft: '0px', paddingRight: '0px'}}
                                    onClick={()=>{this.goTolink('/Beranda')}}
                                />
                                <Chip
                                    label={"> Hasil Supervisi"}
                                    className={this.props.classes.chip}
                                    color="primary"
                                    style={{justifyContent: 'start', marginLeft: 0, padding: 5, borderRadius: 0, borderRight: '1px solid #ccc', paddingLeft: '0px', paddingRight: '0px'}}
                                    onClick={()=>{this.goTolink('/HasilSupervisi')}}
                                />
                                <Chip
                                    label={"> Detail Hasil Supervisi"}
                                    className={this.props.classes.chip}
                                    color="secondary"
                                    // onClick={()=>{this.goTolink('/ManajemenPengguna')}}
                                    style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                                />
                            </div>
                            <Paper className="p-16 m-8">
                                <Typography variant="h6" style={{color:'#1976d2'}}>
                                    Identitas Pengawas
                                </Typography>
                                <Divider/>
                                <br/>
                                <Grid container>
                                    <Grid items xs={12} sm={6}>
                                        Nama: <b>{this.props.pengawas.rows[0].nama}</b>
                                        <br/>
                                        NUPTK: <b>{this.props.pengawas.rows[0].nuptk}</b>
                                    </Grid>
                                    <Grid items xs={12} sm={6}>
                                        Jenis PTK: <b>{this.props.pengawas.rows[0].bidang_studi_id_str}</b>
                                        <br/>
                                        Wilayah: <b>{this.props.pengawas.rows[0].kabupaten}, {this.props.pengawas.rows[0].provinsi}</b>
                                    </Grid>
                                </Grid>
                            </Paper>
                            {this.props.supervisi.rows.map((option)=>{
                                return (
                                    <Paper className="p-16 m-8">
                                        <Typography variant="title">
                                            Supervisi tanggal {new Date(option.tanggal).getDate()} {bulan[new Date(option.tanggal).getMonth()]} {new Date(option.tanggal).getFullYear()}
                                        </Typography>
                                        <Typography variant="caption">
                                            Sekolah yang dikunjungi: <b>{option.nama_sekolah}</b>
                                        </Typography>
                                        <Typography variant="caption">
                                            Nama Pengawas: <b>{option.nama}</b>
                                        </Typography>
                                        <Typography variant="caption">
                                            
                                            <br/>
                                            <b>{option.hasil_pengamatan}</b>
                                        </Typography>
                                        <br/>
                                        {option.children.map((optionChildren)=>{
                                            return (
                                                <Paper className="p-8 mb-8">
                                                    <Typography variant="caption" style={{fontSize:'15px'}}>
                                                        <b>{optionChildren.nama_formulir}</b>
                                                    </Typography>
                                                    <Typography variant="caption">
                                                        Hasil Pengamatan
                                                    </Typography>
                                                    <div style={{border:'1px solid #ccc', padding:'8px'}}>
                                                        {optionChildren.hasil_pengamatan && optionChildren.hasil_pengamatan}
                                                        {!optionChildren.hasil_pengamatan && <span>-</span>}
                                                    </div>
                                                    <Divider className="mb-8"/>
                                                    <Typography variant="caption">
                                                        Analisis Hasil
                                                    </Typography>
                                                    <div style={{border:'1px solid #ccc', padding:'8px'}}>
                                                        {optionChildren.analisis_hasil && optionChildren.analisis_hasil}
                                                        {!optionChildren.analisis_hasil && <span>-</span>}
                                                    </div>
                                                    <Divider className="mb-8"/>
                                                    <Typography variant="caption">
                                                        Solusi
                                                    </Typography>
                                                    <div style={{border:'1px solid #ccc', padding:'8px'}}>
                                                        {optionChildren.solusi && optionChildren.solusi}
                                                        {!optionChildren.solusi && <span>-</span>}
                                                    </div>
                                                    <Divider className="mb-8"/>
                                                    <Typography variant="caption">
                                                        Aktivitas Pendampingan
                                                    </Typography>
                                                    <div style={{border:'1px solid #ccc', padding:'8px'}}>
                                                        {optionChildren.aktivitas_pendampingan && optionChildren.aktivitas_pendampingan}
                                                        {!optionChildren.aktivitas_pendampingan && <span>-</span>}
                                                    </div>
                                                    <Divider className="mb-8"/>
                                                </Paper>
                                            )
                                        })}
                                    </Paper>
                                )
                            })}
                        </div>
                    </FuseAnimate>
                }
            />
        )
    }

}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getSekolah: Actions.getSekolah,
        setKunciKonfirmasiInstrumen: Actions.setKunciKonfirmasiInstrumen,
        getKonfirmasiSelesai: Actions.getKonfirmasiSelesai,
        getKemajuanTotal: Actions.getKemajuanTotal,
        getPeringkatPengisian: Actions.getPeringkatPengisian,
        setLoading: Actions.setLoading,
        setLoadingBesar: Actions.setLoadingBesar,
        setJudul: Actions.setJudul,
        getProsesRapor: Actions.getProsesRapor,
        getRaporMutuRadar: Actions.getRaporMutuRadar,
        setDataTahun: Actions.setDataTahun,
        setDataWilayah: Actions.setDataWilayah,
        getSupervisi: Actions.getSupervisi,
        getSupervisiPengawasLain: Actions.getSupervisiPengawasLain,
        getPengawas: Actions.getPengawas
    }, dispatch);
}

function mapStateToProps({ Sekolah, Instrumen, RaporMutu, Supervisi }) {

    return {
        sekolah: Sekolah.sekolah,
        konfirmasi_instrumen_id: Instrumen.konfirmasi_instrumen_id,
        konfirmasi_instrumen: Instrumen.konfirmasi_instrumen,
        kemajuan_total: Instrumen.kemajuan_total,
        peringkat_pengisian: Instrumen.peringkat_pengisian,
        proses_rapor_mutu: RaporMutu.proses_rapor_mutu,
        rapor_mutu_radar: RaporMutu.rapor_mutu_radar,
        data_tahun: RaporMutu.data_tahun,
        data_wilayah: RaporMutu.data_wilayah,
        supervisi: Supervisi.supervisi,
        supervisi_pengawas_lain: Supervisi.supervisi_pengawas_lain,
        pengawas: Supervisi.pengawas
    }
}

// export default withStyles(styles, {withTheme: true})(Beranda);
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(DetailHasilSupervisi)));



// WEBPACK FOOTER //
// ./src/main/content/Notifikasi/DetailHasilSupervisi.js